import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTextDecoration = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      d="M12 5h-2v12H8V3h8v2h-2v12h-2V5zM8 3a4 4 0 1 0 0 8V3z"
      fill="currentColor"
    />
  </svg>
);
export default SvgTextDecoration;
